import { EventEmitter, inject, Injectable } from '@angular/core';
import { ActionButton, ActionButtonConfigService } from 'gung-common';
import { Invoice } from '../../models/invoice';
import { Observable, of } from 'rxjs';
import { BackendRerouteService } from '../utils/backend-reroute.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceActionConfigService implements ActionButtonConfigService<Invoice>{
  protected backendRerouteService = inject(BackendRerouteService);

  actions = {
    title: '',
    icon: 'far fa-file-pdf',
    class: 'no-hover',
    action: (item: Invoice) => this.backendRerouteService.reroute('download/invoice-pdf/' + item.id + '.pdf')
  };

  getButtons(item: Invoice, eventEmitter?: EventEmitter<Invoice>): Observable<ActionButton<Invoice>[]> {
    return of([this.actions]);
  }
}
